// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-card .item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid #F5F5F5;
}
.list-card .item:last-child {
  border-bottom: none;
}
.list-card .item > :last-child:not(:first-child) {
  margin-left: auto;
}
.list-card .item:hover {
  transition: background-color 300ms linear;
  background-color: #FAFAFA;
}
.list-card .column-flex {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.list-card .column-flex.end {
  align-items: flex-end;
}
.list-card .applicant-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 0;
}
.list-card .applicant-info > a {
  line-height: 1.2;
}
.list-card .applicant-info [class*="icon-svg-"] svg {
  margin-left: 0;
}
.list-card .link-text {
  font-weight: 500;
  display: flex;
  align-items: self-start;
  gap: 0.5rem;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/DashboardWidgets/ListCard/index.less"],"names":[],"mappings":"AAEA;EAEQ,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACFR;ADIQ;EACI,mBAAA;ACFZ;ADKQ;EACI,iBAAA;ACHZ;ADMQ;EACI,yCAAA;EACA,yBAAA;ACJZ;ADdA;EAuBQ,aAAA;EACA,sBAAA;EACA,WAAA;ACNR;ADQQ;EACI,qBAAA;ACNZ;ADtBA;EAiCQ,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,OAAA;EACA,MAAA;ACRR;AD7BA;EAwCY,gBAAA;ACRZ;ADhCA;EA4CY,cAAA;ACTZ;ADnCA;EAiDQ,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;ACXR;AACA,oCAAoC","sourcesContent":["@import \"../../../less/variables.less\";\n\n.list-card {\n    .item {\n        display: flex;\n        align-items: center;\n        gap: 1rem;\n        padding: 0.75rem 0;\n        border-bottom: 1px solid @secondary-50;\n\n        &:last-child {\n            border-bottom: none;\n        }\n\n        &> :last-child:not(:first-child) {\n            margin-left: auto;\n        }\n\n        &:hover {\n            transition: background-color 300ms linear;\n            background-color: @secondary-25;\n        }\n    }\n\n    .column-flex {\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n\n        &.end {\n            align-items: flex-end;\n        }\n    }\n\n    .applicant-info {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        flex: 1;\n        gap: 0;\n\n        >a {\n            line-height: 1.2;\n        }\n\n        [class*=\"icon-svg-\"] svg {\n            margin-left: 0;\n        }\n    }\n\n    .link-text {\n        font-weight: @font-weight-semi-bold;\n        display: flex;\n        align-items: self-start;\n        gap: 0.5rem;\n    }\n}",".list-card .item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #F5F5F5;\n}\n.list-card .item:last-child {\n  border-bottom: none;\n}\n.list-card .item > :last-child:not(:first-child) {\n  margin-left: auto;\n}\n.list-card .item:hover {\n  transition: background-color 300ms linear;\n  background-color: #FAFAFA;\n}\n.list-card .column-flex {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n.list-card .column-flex.end {\n  align-items: flex-end;\n}\n.list-card .applicant-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1;\n  gap: 0;\n}\n.list-card .applicant-info > a {\n  line-height: 1.2;\n}\n.list-card .applicant-info [class*=\"icon-svg-\"] svg {\n  margin-left: 0;\n}\n.list-card .link-text {\n  font-weight: 500;\n  display: flex;\n  align-items: self-start;\n  gap: 0.5rem;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
